import React, { useState } from "react";
import PrimaryButton from "../Buttons/PrimaryButton";
import { Button, Card, Col, Divider, Row, Tooltip } from "antd";
import date from "../../assets/icons/date-time-icon.svg";
import money from "../../assets/icons/money-icon.svg";
import share from "../../assets/icons/share.svg";
import Perso from "../../assets/icons/Perso.svg";
import location from "../../assets/icons/location-border.svg";
import appointment from "../../assets/icons/date.svg";
import teaching from "../../assets/icons/teaching-icon.svg";
import road from "../../assets/icons/road.svg";
import dayjs from "dayjs";
import SharePrograms from "../../components/share-cases/SharePrograms";
import { useNavigate } from "react-router-dom";
import { getCardItem } from "../../components/utils/utils";

interface ServiceCardProps {
  card: any;
  index: number;
  open?: any;
  type: string;
  isCompleted?: any;
}

const ServiceProgramCard = ({
  card,
  index,
  open,
  type,
  isCompleted,
}: ServiceCardProps) => {
  const colors = ["#1f3d60", "#029daf", "#04bb96"];
  const [isShareModalOpen, setIsShareModalVisible] = useState<boolean>(false);
  const navigate = useNavigate();

  const showModal = (id: any) => {
    setIsShareModalVisible(true);
  };

  return (
    <>
      <Card
        className={`takaful--service-card-container ${
          isCompleted && "takaful--completed-program"
        }`}
        style={{ height: "100%" }}
      >
        <div
          className={`takaful--service-card-title-grand`}
          style={{ backgroundColor: colors[index % 3] }}
        >
          <span>{card?.category_id}</span>
        </div>
        <div className="takaful--service-card-image-container">
          <img
            src={card?.title_image_ids}
            alt="service"
            className="takaful--service-card-image"
          />
        </div>

        <Row align={"middle"} style={{ paddingTop: "1rem" }}>
          <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20}>
            <h3 className="takaful--program-card-title">
              {card?.program_name}
            </h3>
          </Col>
          {type === "external" && (
            <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
              <Tooltip
                overlayClassName="takaful--share-tooltip"
                placement="bottom"
                title={"شارك البرنامج على التواصل الإجتماعي"}
              >
                <Button
                  className="takaful--share-btn"
                  onClick={() => showModal(card.id)}
                  style={{ width: "100%", float: "left" }}
                >
                  <img src={share} style={{ width: "1em" }} alt="" />
                </Button>
              </Tooltip>
            </Col>
          )}
        </Row>

        <Row>
          <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
            <p className="takaful--program-card-description">
              {card?.details || "\u00A0"}
            </p>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16} style={{ paddingTop: "0.5rem" }}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <img src={Perso} alt="" width={40} />
          </Col>
          <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20}>
            <span className="takaful--program-card-number">
              {type === "external"
                ? card?.not_beneficiary_targeted_number
                : card?.targeted_number}
              <p>شخص</p>
            </span>
          </Col>
        </Row>

        <Row align={"middle"} className="test">
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <img src={appointment} alt="" width={40} />
          </Col>
          <Col xxl={20} xl={20} lg={20} md={20} sm={20}>
            <div className="takaful--dates-container">
              <span className="takaful--program-card-date">
                <p>البداية:</p>
              </span>
              <span className="takaful--program-card-date">
                {card?.start_date
                  ? dayjs(card?.start_date, "YYYY-MM-DD").format("YYYY/MM/DD")
                  : ""}
              </span>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Divider
                  type="vertical"
                  className="takaful--program-card-divider"
                />
              </div>
              <span className="takaful--program-card-date">
                <p>النهاية:</p>
              </span>
              <span className="takaful--program-card-date">
                {card?.end_date
                  ? dayjs(card?.end_date, "YYYY-MM-DD").format("YYYY/MM/DD")
                  : ""}
              </span>
            </div>
          </Col>
        </Row>

        <Row align={"middle"} gutter={16}>
          <Col xxl={4} xl={4} lg={4} md={4} sm={4} xs={4}>
            <img src={location} alt="" width={40} />
          </Col>
          <Col xxl={20} xl={20} lg={20} md={20} sm={20} xs={20}>
            <span className="takaful--program-card-date">
              {card?.activity_place}
            </span>
          </Col>
        </Row>
        {getCardItem(
          "الأيام المتبقية للترشح",
          card?.inscription_remaining_duration,
          "يوم",
          date
        )}

        {type === "external" &&
          getCardItem("قيمة الإشتراك", card?.registration_fees, "ريال", money)}
        {getCardItem("عدد الحصص", card?.total_lessons, "حصة", teaching)}
        {type === "external"
          ? getCardItem(
              "عدد المواقع",
              card?.remaining_not_beneficiary_application_count === 0
                ? card?.remaining_not_beneficiary_provision_application_count
                : card?.remaining_not_beneficiary_application_count,
              "موقع",
              road
            )
          : getCardItem(
              "عدد المواقع",
              card?.remaining_beneficiary_application_count === 0
                ? card?.remaining_beneficiary_provision_application_count
                : card?.remaining_beneficiary_application_count,
              "موقع",
              road
            )}

        {type === "internal" ? (
          <PrimaryButton
            title="الترشح"
            style={{ width: "100%", marginTop: "1rem" }}
            onClick={open}
            disabled={
              !(
                new Date() >= new Date(card?.inscription_start) &&
                new Date() <= new Date(card?.inscription_deadline)
              )
            }
          />
        ) : (
          <PrimaryButton
            title="الترشح"
            style={{ width: "100%", marginTop: "1rem" }}
            onClick={() => navigate(`/program/${card?.access_token}`)}
            disabled={
              // eslint-disable-next-line eqeqeq
              card?.remaining_not_beneficiary_application_count == 0 &&
              // eslint-disable-next-line eqeqeq
              card?.remaining_not_beneficiary_provision_application_count == 0
            }
          />
        )}
      </Card>

      <SharePrograms
        isShareModalOpen={isShareModalOpen}
        setIsShareModalVisible={() => setIsShareModalVisible(false)}
        url={`${window.location.origin}/program/${card?.access_token}`}
        title={card?.program_name}
      />
    </>
  );
};

export default ServiceProgramCard;
